import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RequestStatus } from "../core/model/request-status";
import { RequestStatusService } from "../core/service/request-status.service";

@Component({
  selector: "app-request-status",
  templateUrl: "./request-status.component.html",
  styleUrls: ["./request-status.component.scss"],
})
export class RequestStatusComponent implements OnInit {
  status: RequestStatus[];

  constructor(
    private _router: Router,
    private _requestStatusService: RequestStatusService
  ) {}

  ngOnInit() {
    this.getRequestStatus();
  }

  getRequestStatus() {
    this._requestStatusService.getAllRequestStatus().subscribe(
      (data) => {
        this.status = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
